export default function isTableCellsEmpty(editor, cells) {
  return cells.every(function (cell) {
    return cell.text === '';
  });
}